import { useEffect, useState } from 'react';
import { Box, Typography } from '@mui/material';
import './EditNotifications.scss';
import SPForm from '../../Form/SPForm';
import editNotificationsForm from '../../Form/json/editNotificationsFormFields.json';
import SPFormButton from '../../Form/SPFormButton';
import {
  doFormErrorMsgs,
  getUserInfoById,
  isEmpty
} from '../../../../pages/SellerProfile/APIs/Helpers';
import GetLabels from '../../../../pages/SellerProfile/GetLabels';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { editNotificationStart, setSubmittingSuccess } from '../../../../redux/slices/notificationSlice';
import { setFormLoading,setShowSuccessPopUp,setModalType } from '../../../../redux/slices/sellerProfileSlice';
export const EditNotifications = ({ email, curr_user_id, hasMandatory }) => {
  const [status, setStatus] = useState('');
  const [editNotificationsFormFields, setEditNotificationsFormFields] = useState<Record<string, any>>({});
  const { notificationTypes, notificationRecipients, loading, submitting, submittingSuccess } =
    useSelector((state: any) => state.notification);
    const {formLoading,spPageText,formUpdates} = useSelector((state: any) => state.sellerProfile);
  const formData = getUserInfoById(notificationRecipients, curr_user_id);
  const dispatch = useDispatch();
  const { t, i18n } = useTranslation();

  useEffect(() => {
    setEditNotificationsFormFields(editNotificationsForm);
  }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  , [editNotificationsForm]);


  useEffect(() => {
    const notification_type = `notification_type_${i18n.language}`;

    const updatedOptions: Record<string, any> = {...editNotificationsForm.notifications.options};

    notificationTypes.forEach((notif, i) => {
      editNotificationsForm.notifications.options[notif.notification_type_id][
        'label'
      ] = notif[notification_type] || '';
      if (i === notificationTypes.length - 1 && formLoading) {
        dispatch(setFormLoading(false));
      }
    });
    setEditNotificationsFormFields(prev => ({
      notifications: {
        ...prev.notifications,
        options: updatedOptions
      }
    }))
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [i18n.language, notificationTypes]);

  useEffect(() => {
    if (submittingSuccess) {
      dispatch(setModalType(''));
     dispatch(setShowSuccessPopUp(status));
      setStatus('');
      dispatch(setSubmittingSuccess(false));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [submittingSuccess]);
   

  const submitFormFields = async (formName) => {
    const getNotificationUpdates: string[] = [];
    const getCheckedNotifs =
      formUpdates[formName]?.notifications?.options;
    const notif_lang_pref =
      formUpdates[formName]?.notifications?.options
        .preferred_language_type.content;
    Object.keys(getCheckedNotifs).forEach((notif) => {
      if (getCheckedNotifs[notif]['checked']) {
        getNotificationUpdates.push(getCheckedNotifs[notif].id);
      }
    });
    const updatedNotifications = getNotificationUpdates;
    const stillHasNotifs = updatedNotifications.length > 0;
    const useSuccessMsg = stillHasNotifs
      ? `spPageText.${formName}Success`
      : `spPageText.${formName}RemovedSuccess`;
    const successMsg = GetLabels(useSuccessMsg,spPageText);
  setStatus(successMsg);
    try {
      dispatch(
        editNotificationStart({
          curr_user_id,
          updates: getNotificationUpdates,
          notif_lang_pref,
          
        })
      );
    } catch (error) {
      doFormErrorMsgs(error, dispatch,spPageText);
      console.log('Error updating user notificaitons', error);
    }
  };

  const disableForm = formData?.notificationsMandatory;
  return !isEmpty(notificationTypes) && !loading ? (
    <Box className="editUserCardPopupContainer">
      <Box className="editUserCardPopupBody">
        <Typography className="emailDescription">
          {t('sellerProfile.dashboard.notifSentTo')}{' '}
          <span className="emailAddress">{email}</span>
        </Typography>
        {hasMandatory && (
          <Typography sx={{ marginTop: '10px' }}>
            {t('sellerProfile.dashboard.mandatoryNotif')}
          </Typography>
        )}
        <SPForm
          cols="single"
          compName="editUserCardPopupForm"
          formFields={editNotificationsFormFields}
          user_id={curr_user_id}
          formData={formData}
          formName="editNotifications"
          key="editNotificationsForm"
          userList={notificationRecipients}
          disableForm={disableForm}
        />
        {!formLoading && (
          <SPFormButton
            label={t('sellerProfile.dashboard.saveUpdates')}
            compName="updateUserSettings"
            formName="editNotifications"
            handleClick={() => submitFormFields('editNotifications')}
            showLoading={submitting}
          />
        )}
      </Box>
    </Box>
  ) : (
    <></>
  );
};
